<template>
  <div class="change-pager" v-if="lessonList.length > 0">
    <section class="scroll-list-wrap">
      <div class="header">
        <div class="one-lesson" v-for="(item, index) in lessonList" :key="index">
          <div class="cover_image">
            <img :src="item.cover_image" alt="" style="object-fit: cover">
          </div>
          <div class="content">
            <p class="name">{{ item.name }}</p>
            <span class="camp_num">第{{ item.camp_num }}期</span>
            <span class="training_date">开营时间: {{ item.training_date }}</span>
          </div>
        </div>
      </div>
      <div class="desc">
        <p class="p">换号信息</p>
        <div>
          <p class="image"><img :src="user_info.headimgurl" alt=""></p>
          <p class="nickname"> {{ user_info.nickname }}</p>
          <p class="user_id"> UID: {{ user_info.user_id }}</p>
        </div>
      </div>
      <div class="remark">
          <p class="tips">如发现用错微信，可重新用正确的微信号扫码或打开链接</p>
      </div>

      <div class="has_apply" v-if="has_apply">
        <p>换号申请已提交，请耐心等待</p>
      </div>

      <div class="footer" v-if="!has_apply">
        <input type="button" value="申请换号" class="btn_apply" @click="applyChange"/>
      </div>
    </section>
  </div>

  <div class="change-empty" v-else>
    <div class="content">
      <p>您没有可换号的营期</p>
      <p>请联系您的班长</p>
      <img src="../../assets/my-clock-in-empty.png"/>
    </div>

  </div>
</template>

<script>

import { queryChangeSeries, changeAccountApply, checkLogin } from '@/api/api';
import { Toast } from 'vant';

export default {
  name: 'change_account',
  data() {
    return {
      has_apply: false,
      lessonList: [],
      user_info: {},
    };
  },

  beforeCreate() {
    checkLogin().then((res) => {
      if (!res.data.result) {
        Toast('请先登录');
        window.location.href = res.data.login_url;
      } else {
        console.log('用户已登录');
      }
    });
  },

  created() {
    queryChangeSeries(this.$route.params.user_id, this.$route.query.series_ids).then((res) => {
      this.lessonList = res.items;
      this.user_info = res.user_info;
      this.has_apply = res.has_apply;
    });
  },

  methods: {
    // 复制链接
    applyChange() {
      Toast('申请成功');
      const userId = parseInt(this.$route.params.user_id, 10);
      const seriesIds = this.$route.query.series_ids;
      const newUserId = this.user_info.user_id;
      changeAccountApply(userId, seriesIds, newUserId).then(() => {
        Toast('申请成功');
        this.has_apply = true;
      });
    }
  },
};
</script>

<style scoped lang="stylus">
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.change-pager {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 0 auto;
  width: 100vw;
  height: 100vh;
  max-width: 600px;
  overflow: hidden;
  background-color #F6F6F6
  padding 16px;
}

/* header start */

.change-pager .header {
  width: 100%;
  background-color #fff;
  margin: 0 auto;
  border-radius 8px;
}

.change-pager .one-lesson {
  clear: both
  height 107px;
  padding: 16px;
}

.change-pager .one-lesson .cover_image {
  float left;
  border-radius 10px;
}

.change-pager .one-lesson .cover_image img{
  width: 60px;
  height 75px;
  border-radius 3.6px;
}

.change-pager .one-lesson .content {
  width: 80%;
  float left;
  padding-left: 12px;
}

.change-pager .one-lesson .content .name {
  width: 100%;
  font-size 18px;
  text-overflow ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*autoprefixer: off*/
  /*autopprefixer: on*/
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-family PingFangSC-Semibold, sans-serif;
  margin 8px 0 24px 0;
  color: #191919;
  font-weight 600
}

.change-pager .one-lesson .content .camp_num {
  margin-right 8px;
}

.change-pager .one-lesson .content .camp_num,
.change-pager .one-lesson .content .training_date {
  font-size 12px;
  color: #999;
  margin-top 29px;
}

/* header end*/

/* desc start */
.change-pager .desc {
  height 224px;
  margin: 16px auto;
  padding-top: 16px;
  background-color #fff;
  border-radius 8px;
}

.change-pager .desc .p {
  font-size 16px;
  font-family PingFangSc-Medium, sans-serif;
  font-weight 600;
  padding-left 12px;
}

.change-pager .desc div {
  width: 100%;
  text-align center;
  margin 30px 0
}

.change-pager .desc div img {
  width: 61px;
  height: 61px;
  margin: 0 auto;
}

.change-pager .desc div .nickname {
  font-family PingFangSc-Medium, sans-serif;
  font-weight 600;
  font-size 16px;
  margin-top 12px;
}

.change-pager .desc div .user_id {
  font-size 14px;
  color #999;
  margin-top 7px;
}

.change-pager .remark {
  font-size 12px;
  color: #999;
  margin-top 14px;
}
.change-pager .has_apply {
  width: 100%;
  font-size 14px;
  color: #999;
  text-align center;
  margin-top 24px;
}
/* desc end */

/* footer start */
.change-pager .footer {
  width 91%;
  height 40px;
  position absolute
  bottom 38px;
}

.change-pager .footer .btn_apply {
  width 100%;
  height 40px;
  border: none;
  outline: none;
  border-radius: 6px;
  background: linear-gradient(to right, #FCB13F ,#FA8C1D );
  box-shadow: 0px 2px 4px 0px rgba(250, 140, 29, .3);
  line-height: 24px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  font-family PingFangSc-Medium, sans-serif;
  font-weight 600
}

/* footer end */

.change-empty {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  margin: auto;
  width: 100vw;
  height: 100vh;
  max-width: 600px;
  overflow: hidden;
  text-align center;
  background-color #fff
}


.change-empty .content {
  position relative;
  top: 25%;
}

.change-empty .content p {
  font-size 14px;
  color #999;
  overflow-wrap: break-word;
  font-family: PingFangSC-Regular;
  text-align: center;
  line-height: 20px;
}

.change-empty .content img {
  margin-top 18px;
  width: 255px;
  height 168px
}
</style>
